import { createContext } from "react"

export const AppContext = createContext({appContext: null, setAppContext: null})